// extracted by mini-css-extract-plugin
export var deleteIcon = "_u2-5";
export var deleteOption = "_u2-3";
export var divider = "_u2-2";
export var downloadIcon = "_u2-4";
export var drawer = "_u2-0";
export var drawerFooter = "_u2-6";
export var drawerOpen = "_u2-1";
export var highlighted = "_u2-7";
export var lighterHighlight = "_u2-8";